import { george, observer, pr, React, RouteComponentProps, theme, ui, debug } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../signing/views/SigningComponent";
import { GooglePayRoutes } from "./GooglePayRoutes";
import { GooglePayStore } from "./GooglePayStore";

type IProps = RouteComponentProps<{}> & {
    store: GooglePayStore;
};

@observer
export class GooglePaySigning extends React.Component<IProps, {}> {
    render() {
        return (
            <SigningComponent
                useWebVersion
                signingInfo={this.props.store.signInfo}
                content={
                    <>
                        <div style={{ padding: theme.MARGIN }}>
                            <george.SectionTitle style={{ marginTop: 0 }}>
                                {ui.__("common.summary")}
                            </george.SectionTitle>
                            <pr.LightSeparatorLine spacing={theme.MARGIN} />
                            <george.ResponsiveSummaryElement label={ui.__("signing.action.label")}>
                                <pr.SigningLabel>
                                    {ui.__("googlePay.summary.action.description")}
                                </pr.SigningLabel>
                            </george.ResponsiveSummaryElement>
                        </div>
                    </>

                }
                onSuccess={(response: ISigningResponse) => {
                    debug.log("### signing success", response);
                    pushRoute(GooglePayRoutes.SUCCESS);
                }}
                onRetry={async () => {
                    await this.props.store.postGooglePayApproval();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/googlePay/GooglePaySigning.tsx